import { render, staticRenderFns } from "./DualAxisBarTrendWidget.vue?vue&type=template&id=c02e6cae"
import script from "./DualAxisBarTrendWidget.vue?vue&type=script&lang=js"
export * from "./DualAxisBarTrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports